// tsc src/lib/utils/throttle.ts && mv src/lib/utils/throttle.js backend/src/utils/
export function throttle(func, ms) {
    var isThrottled = false;
    var savedArgs;
    var savedThis;
    function wrapper() {
        if (isThrottled) {
            savedArgs = arguments;
            savedThis = this;
            return;
        }
        func.apply(this, arguments);
        isThrottled = true;
        setTimeout(function () {
            isThrottled = false;
            if (savedArgs) {
                wrapper.apply(savedThis, savedArgs);
                savedArgs = savedThis = null;
            }
        }, ms);
    }
    return wrapper;
}
